import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { TranslocoService } from '@jsverse/transloco';
import { TitleService } from 'src/services/title.service';
import { AppNav } from 'src/routes/app-nav';
import { MessageService } from 'primeng/api';
import { Table } from 'primeng/table';
import { HttpErrorResponse } from '@angular/common/http';
import Helpers from 'src/shared/helpers';
import { TransactionQueryListItemDTO } from '@/interfaces/transactionQueryListItemDTO.interface';
import { TransactionQueryService } from '@/services/transaction-query.service';

@Component({
  selector: 'app-transaction-query-status-page',
  standalone: false,
  templateUrl: './transaction-query-status-page.component.html',
})
export class TransactionQueryStatusPageComponent implements OnInit, OnDestroy {
  private destroyed = new Subject<any>();
  private helpers: Helpers;

  messageKey: string = 'transactionQueryStatusPage';
  queryEntries: TransactionQueryListItemDTO[] = [];
  loading: boolean = false;

  @ViewChild(Table) queryTable!: Table;

  constructor(
    private titleService: TitleService,
    private translocoService: TranslocoService,
    private messageService: MessageService,
    private transactionQueryService: TransactionQueryService,
  ) {
    this.helpers = Helpers.getInstance(this.translocoService);
  }

  ngOnInit(): void {
    this.titleService.setTitle(AppNav.TransactionQueryStatus.title);
    this.loadQueries();
  }

  loadQueries(): void {
    this.loading = true;
    this.transactionQueryService.getQueries().subscribe({
      next: (response: TransactionQueryListItemDTO[]) => {
        this.loading = false;
        this.queryEntries = response;
      },
      error: (response: HttpErrorResponse) => {
        this.loading = false;
        this.helpers.showApiResponseMessage(
          response,
          this.messageService,
          this.messageKey,
        );
      },
    });
  }

  refresh(): void {
    this.messageService.clear();
    this.loadQueries();
  }

  getStatusClass(status: string): string {
    switch (status) {
      case 'Completed':
        return 'bg-green-lighter text-status-green';
      case 'Error':
        return 'bg-red-lighter text-status-red';
      case 'Pending':
        return 'bg-orange-light2 text-orange-default';
      default:
        return 'bg-grey-lighter text-grey-default';
    }
  }

  ngOnDestroy(): void {
    this.destroyed.next(undefined);
    this.destroyed.complete();
  }
}
